import { ApplicationSent } from '@/app/pages/family_application/application_sent/Page.tsx'
import AttestationView from '@/app/pages/family_application/attestations/Page.tsx'
import { IdentityVerificationWizardProvider } from '@/app/pages/family_application/identity_verification/__legacy_do_not_use/IdentityVerificationWizardProvider'
import { IdentitySuccessVerified } from '@/app/pages/family_application/identity_verification/identity-submitted/_components/IdentitySuccessVerified'
import IdentitySubmittedPage from '@/app/pages/family_application/identity_verification/identity-submitted/Page'
import IdentityDocumentCapture from '@/app/pages/family_application/identity_verification/identity_verify_info/IdentityDocumentCapture.tsx'
import { IdentityDocumentReview } from '@/app/pages/family_application/identity_verification/identity_verify_info/IdentityDocumentReview.tsx'
import IdentityManualInfo from '@/app/pages/family_application/identity_verification/identity_verify_info/IdentityManualInfo.tsx'
import IdentitySuccessManualVerified from '@/app/pages/family_application/identity_verification/identity_verify_info/IdentitySuccessManualVerified.tsx'
import IdentityVerificationPage from '@/app/pages/family_application/identity_verification/Page.tsx'
import IncomeAttestations from '@/app/pages/family_application/income_verification/attestations/IncomeAttestations'
import { CaptureInstructionsTaxable } from '@/app/pages/family_application/income_verification/capture-instructions/capture-instructions-taxable'
import { FilingStatusPage } from '@/app/pages/family_application/income_verification/filing-status/FilingStatus'
import { HouseholdSizePage } from '@/app/pages/family_application/income_verification/HouseholdSize.tsx'
import { IncomeHomePage } from '@/app/pages/family_application/income_verification/IncomeHome.tsx'
import { IncomeVerificationType } from '@/app/pages/family_application/income_verification/IncomeVerificationType'
import { IncomeVerificationWizardProvider } from '@/app/pages/family_application/income_verification/IncomeVerificationWizardProvider.tsx'
import { DocumentCapturePage } from '@/app/pages/family_application/income_verification/manual-upload/DocumentCapture'
import { DocumentSubmittedPage } from '@/app/pages/family_application/income_verification/manual-upload/DocumentSubmitted'
import { ManualUploadDescription } from '@/app/pages/family_application/income_verification/manual-upload/ManualUploadDescription'
import IncomeVerificationPage from '@/app/pages/family_application/income_verification/Page'
import { SelectHouseholdMemberPage } from '@/app/pages/family_application/income_verification/SelectHouseholdMember.tsx'
import SummaryPage from '@/app/pages/family_application/income_verification/summary/SummaryPage'
import { VerificationOutcome } from '@/app/pages/family_application/income_verification/summary/VerificationOutcome'
import { TaxCommissionInfoPage } from '@/app/pages/family_application/income_verification/tax_comission/TaxComissionInfoPage'
import TaxCommissionSetupPage from '@/app/pages/family_application/income_verification/tax_comission/TaxCommissionSetupPage.tsx'
import TaxCommissionAttestation from '@/app/pages/family_application/income_verification/tax_comission/TaxCommissionAttestations'
import { TaxCommissionConfirmationPage } from '@/app/pages/family_application/income_verification/tax_comission/TaxCommissionConfirmation'
import NewFamilyAppLandingPage from '@/app/pages/family_application/Page'
import ResidencyAlternativeDocsCapture from '@/app/pages/family_application/residency_verification/ResidencyAlternativeDocsCapture.tsx'
import ResidencyAlternativeDocsInfo from '@/app/pages/family_application/residency_verification/ResidencyAlternativeDocsInfo.tsx'
import ResidencyAlternativeDocsReview from '@/app/pages/family_application/residency_verification/ResidencyAlternativeDocsReview.tsx'
import ResidencyCaptureDetails from '@/app/pages/family_application/residency_verification/ResidencyCaptureDetails.tsx'
import ResidencyDocsVerify from '@/app/pages/family_application/residency_verification/ResidencyDocsVerify.tsx'
import ResidencyDocumentCapture from '@/app/pages/family_application/residency_verification/ResidencyDocumentCapture.tsx'
import { ResidencyDocumentReview } from '@/app/pages/family_application/residency_verification/ResidencyDocumentReview.tsx'
import ResidencySuccessVerified from '@/app/pages/family_application/residency_verification/ResidencySuccessVerified.tsx'
import ResidencyVerifyInstructionsPage from '@/app/pages/family_application/residency_verification/ResidencyVerifyInstructionsPage.tsx'
import ReviewApplicationPage from '@/app/pages/family_application/review/Page.tsx'
import { AdditionalStudent } from '@/app/pages/family_application/student_details/AdditionalStudent.tsx'
import { RelationshipCaptureInstructions } from '@/app/pages/family_application/student_details/capture_instructions/RelationshipCaptureInstructions'
import { SpecialEducationCaptureInstructions } from '@/app/pages/family_application/student_details/capture_instructions/SpecialEducationCaptureInstructions'
import { DocumentCapturePage as StudentDetailsDocumentCapture } from '@/app/pages/family_application/student_details/DocumentCapturePage'
import { DocumentReviewPage as StudentDetailsDocumentReview } from '@/app/pages/family_application/student_details/DocumentReviewPage'
import { SpecialEducationDocumentType } from '@/app/pages/family_application/student_details/SpecialEducationDocumentType'
import { SpecialEducationSubmittedPage } from '@/app/pages/family_application/student_details/SpecialEducationSubmittedPage'
import { StudentBirthdateAdditionalWarning } from '@/app/pages/family_application/student_details/StudentBirthdateAdditionalWarning.tsx'
import { StudentCapInstructPage } from '@/app/pages/family_application/student_details/StudentCapInstructPage.tsx'
import { StudentCapturePage } from '@/app/pages/family_application/student_details/StudentCapturePage.tsx'
import { StudentDetailsSubPage } from '@/app/pages/family_application/student_details/StudentDetailsSubPage.tsx'
import { StudentDetailsWizardProvider } from '@/app/pages/family_application/student_details/StudentDetailsWizardProvider.tsx'
import { StudentPhotoReviewPage } from '@/app/pages/family_application/student_details/StudentPhotoReviewPage.tsx'
import { StudentPrepPage } from '@/app/pages/family_application/student_details/StudentPrepPage.tsx'
import { StudentSubmittedPage } from '@/app/pages/family_application/student_details/StudentSubmittedPage.tsx'
import StudentSuccessVerified from '@/app/pages/family_application/student_details/StudentSuccessVerified'
import { SubmittedDocument } from '@/app/pages/family_application/student_details/SubmittedDocument'
import { AppRoutePaths } from '@/routing/route_paths.ts'
import { RouteObject } from 'react-router-dom'

export const APPLICATION_ROUTES: RouteObject[] = [
  {
    path: AppRoutePaths.family_application.residency_verification.index,
    element: (
      <IdentityVerificationWizardProvider>
        <ResidencyVerifyInstructionsPage />
      </IdentityVerificationWizardProvider>
    ),
  },
  {
    path: AppRoutePaths.family_application.residency_verification
      .document_capture,
    element: (
      <IncomeVerificationWizardProvider>
        <ResidencyDocumentCapture />
      </IncomeVerificationWizardProvider>
    ),
  },
  {
    path: AppRoutePaths.family_application.residency_verification
      .document_review,
    element: (
      <IncomeVerificationWizardProvider>
        <ResidencyDocumentReview />
      </IncomeVerificationWizardProvider>
    ),
  },
  {
    path: AppRoutePaths.family_application.residency_verification.enter_details,
    element: (
      <IdentityVerificationWizardProvider>
        <ResidencyCaptureDetails />
      </IdentityVerificationWizardProvider>
    ),
  },
  {
    path: AppRoutePaths.family_application.residency_verification
      .success_verification,
    element: (
      <IdentityVerificationWizardProvider>
        <ResidencySuccessVerified />
      </IdentityVerificationWizardProvider>
    ),
  },
  {
    path: AppRoutePaths.family_application.residency_verification
      .alternative_docs_info,
    element: (
      <IdentityVerificationWizardProvider>
        <ResidencyAlternativeDocsInfo />
      </IdentityVerificationWizardProvider>
    ),
  },
  {
    path: AppRoutePaths.family_application.residency_verification
      .alternative_docs_capture,
    element: (
      <IncomeVerificationWizardProvider>
        <ResidencyAlternativeDocsCapture />
      </IncomeVerificationWizardProvider>
    ),
  },
  {
    path: AppRoutePaths.family_application.residency_verification
      .alternative_docs_review,
    element: (
      <IncomeVerificationWizardProvider>
        <ResidencyAlternativeDocsReview />
      </IncomeVerificationWizardProvider>
    ),
  },
  {
    path: AppRoutePaths.family_application.residency_verification
      .alternative_docs_verify,
    element: (
      <IncomeVerificationWizardProvider>
        <ResidencyDocsVerify />
      </IncomeVerificationWizardProvider>
    ),
  },
  {
    path: AppRoutePaths.family_application.index,
    element: <NewFamilyAppLandingPage />,
  },
  {
    path: AppRoutePaths.family_application.identity_verification.index,
    element: (
      <IdentityVerificationWizardProvider>
        <IdentityVerificationPage />
      </IdentityVerificationWizardProvider>
    ),
  },

  {
    path: AppRoutePaths.family_application.identity_verification.submitted,
    element: <IdentitySubmittedPage />,
  },
  {
    path: AppRoutePaths.family_application.identity_verification
      .success_verification,
    element: (
      <IdentityVerificationWizardProvider>
        <IdentitySuccessVerified />
      </IdentityVerificationWizardProvider>
    ),
  },
  {
    path: AppRoutePaths.family_application.identity_verification
      .success_manual_verification,
    element: (
      <IdentityVerificationWizardProvider>
        <IdentitySuccessManualVerified />
      </IdentityVerificationWizardProvider>
    ),
  },
  {
    path: AppRoutePaths.family_application.identity_verification.manual_info,
    element: (
      <IdentityVerificationWizardProvider>
        <IdentityManualInfo />
      </IdentityVerificationWizardProvider>
    ),
  },
  {
    path: AppRoutePaths.family_application.identity_verification
      .document_capture,
    element: (
      <IncomeVerificationWizardProvider>
        <IdentityDocumentCapture />
      </IncomeVerificationWizardProvider>
    ),
  },
  {
    path: AppRoutePaths.family_application.identity_verification
      .document_review,
    element: (
      <IncomeVerificationWizardProvider>
        <IdentityDocumentReview />
      </IncomeVerificationWizardProvider>
    ),
  },
  {
    path: AppRoutePaths.family_application.student_details.index,
    element: <StudentPrepPage />,
  },
  {
    path: AppRoutePaths.family_application.student_details.enter_details,
    element: <StudentDetailsSubPage />,
  },
  {
    path: AppRoutePaths.family_application.student_details.capture_instructions,
    element: <StudentCapInstructPage />,
  },
  {
    path: AppRoutePaths.family_application.student_details.capture,
    element: (
      <StudentDetailsWizardProvider>
        <StudentCapturePage />
      </StudentDetailsWizardProvider>
    ),
  },
  {
    path: AppRoutePaths.family_application.student_details.photo_review,
    element: (
      <StudentDetailsWizardProvider>
        <StudentPhotoReviewPage />
      </StudentDetailsWizardProvider>
    ),
  },
  {
    path: AppRoutePaths.family_application.student_details.document_submitted,
    element: <StudentSubmittedPage />,
  },
  {
    path: AppRoutePaths.family_application.student_details.relationship.index,
    element: (
      <StudentDetailsWizardProvider>
        <RelationshipCaptureInstructions />
      </StudentDetailsWizardProvider>
    ),
  },
  {
    path: AppRoutePaths.family_application.student_details.relationship.capture,
    element: (
      <StudentDetailsWizardProvider>
        <StudentDetailsDocumentCapture />
      </StudentDetailsWizardProvider>
    ),
  },
  {
    path: AppRoutePaths.family_application.income_verification.attestations,
    element: <IncomeAttestations />,
  },
  {
    path: AppRoutePaths.family_application.student_details.relationship
      .document_review,
    element: (
      <StudentDetailsWizardProvider>
        <StudentDetailsDocumentReview />
      </StudentDetailsWizardProvider>
    ),
  },
  {
    path: AppRoutePaths.family_application.income_verification
      .success_verification,
    element: <SummaryPage />,
  },
  {
    path: AppRoutePaths.family_application.student_details.relationship
      .document_submitted,
    element: <SubmittedDocument />,
  },
  {
    path: AppRoutePaths.family_application.student_details.success_verification,
    element: (
      <StudentDetailsWizardProvider>
        <StudentSuccessVerified />
      </StudentDetailsWizardProvider>
    ),
  },
  {
    path: AppRoutePaths.family_application.student_details.additional_details,
    element: (
      <StudentDetailsWizardProvider>
        <StudentBirthdateAdditionalWarning />
      </StudentDetailsWizardProvider>
    ),
  },
  {
    path: AppRoutePaths.family_application.student_details.special_education
      .index,
    element: (
      <StudentDetailsWizardProvider>
        <SpecialEducationDocumentType />
      </StudentDetailsWizardProvider>
    ),
  },
  {
    path: AppRoutePaths.family_application.income_verification
      .tax_commission_confirmation,
    element: <TaxCommissionConfirmationPage />,
  },

  {
    path: AppRoutePaths.family_application.student_details.special_education
      .capture_instructions,
    element: (
      <StudentDetailsWizardProvider>
        <SpecialEducationCaptureInstructions />
      </StudentDetailsWizardProvider>
    ),
  },
  {
    path: AppRoutePaths.family_application.student_details.special_education
      .document_capture,
    element: (
      <StudentDetailsWizardProvider>
        <StudentDetailsDocumentCapture />
      </StudentDetailsWizardProvider>
    ),
  },
  {
    path: AppRoutePaths.family_application.student_details.special_education
      .document_review,
    element: (
      <StudentDetailsWizardProvider>
        <StudentDetailsDocumentReview />
      </StudentDetailsWizardProvider>
    ),
  },

  {
    path: AppRoutePaths.family_application.student_details.special_education
      .document_submitted,
    element: (
      <StudentDetailsWizardProvider>
        <SpecialEducationSubmittedPage />
      </StudentDetailsWizardProvider>
    ),
  },
  {
    path: AppRoutePaths.family_application.income_verification
      .tax_commission_verify_account,
    element: <TaxCommissionSetupPage />,
  },
  {
    path: AppRoutePaths.family_application.student_details.attestations.id,
    element: (
      <StudentDetailsWizardProvider>
        <AttestationView />
      </StudentDetailsWizardProvider>
    ),
  },
  {
    path: AppRoutePaths.family_application.student_details.additional_student,
    element: <AdditionalStudent />,
  },
  {
    path: AppRoutePaths.family_application.income_verification.index,
    element: <IncomeHomePage />,
  },
  {
    path: AppRoutePaths.family_application.income_verification.household_size,
    element: <HouseholdSizePage />,
  },
  {
    path: AppRoutePaths.family_application.income_verification.tax_commission,
    element: <TaxCommissionInfoPage />,
  },
  {
    path: AppRoutePaths.family_application.income_verification.filing_status,
    element: <FilingStatusPage />,
  },
  {
    path: AppRoutePaths.family_application.income_verification
      .tax_commission_confirmation,
    element: <TaxCommissionSetupPage />,
  },
  {
    path: AppRoutePaths.family_application.income_verification
      .select_household_member,
    element: (
      <IncomeVerificationWizardProvider>
        <SelectHouseholdMemberPage />
      </IncomeVerificationWizardProvider>
    ),
  },

  {
    path: AppRoutePaths.family_application.income_verification
      .social_security_number,
    element: <IncomeVerificationPage />,
  },
  {
    path: AppRoutePaths.family_application.income_verification
      .capture_instructions,
    element: (
      <IncomeVerificationWizardProvider>
        <CaptureInstructionsTaxable />
      </IncomeVerificationWizardProvider>
    ),
  },
  {
    path: AppRoutePaths.family_application.income_verification.document_capture,
    element: (
      <IncomeVerificationWizardProvider>
        <DocumentCapturePage />
      </IncomeVerificationWizardProvider>
    ),
  },
  {
    path: AppRoutePaths.family_application.income_verification
      .document_instructions,
    element: (
      <IncomeVerificationWizardProvider>
        <ManualUploadDescription />
      </IncomeVerificationWizardProvider>
    ),
  },
  {
    path: AppRoutePaths.family_application.income_verification.completed,
    element: (
      <IncomeVerificationWizardProvider>
        <VerificationOutcome />
      </IncomeVerificationWizardProvider>
    ),
  },
  {
    path: AppRoutePaths.family_application.income_verification
      .document_submitted,
    element: (
      <IncomeVerificationWizardProvider>
        <DocumentSubmittedPage />
      </IncomeVerificationWizardProvider>
    ),
  },
  {
    path: AppRoutePaths.family_application.income_verification
      .tax_commission_attestation,
    element: (
      <IncomeVerificationWizardProvider>
        <TaxCommissionAttestation />
      </IncomeVerificationWizardProvider>
    ),
  },

  {
    path: AppRoutePaths.family_application.income_verification
      .alternative_verification_method,
    element: <IncomeVerificationType />,
  },
  {
    path: AppRoutePaths.family_application.review_application,
    element: <ReviewApplicationPage />,
  },
  {
    path: AppRoutePaths.family_application.application_sent,
    element: <ApplicationSent />,
  },
]

export function attestationRoute(attestationId: string) {
  return AppRoutePaths.family_application.student_details.attestations.id.replace(
    ':attestation_id',
    attestationId
  )
}
